(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quantity"] && !Shopify.designMode) return;
  try {
    class SmBundlePicker {
  constructor(el) {
    this.el = el;
    this.cards = [...el.querySelectorAll('[data-bundle-qty]')];
    this.qtyComponent = el.closest('product-form-component')
      ?.querySelector('quantity-selector-component[ref="quantitySelector"]')
      ?? document.querySelector('quantity-selector-component[ref="quantitySelector"]');

    const productForm = el.closest('product-form-component');
    this._variantInput = productForm?.querySelector('input[name="id"]')
      ?? document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
    this._mainVariantId = this._variantInput?.value || null;
    this._soleVariantId = this._variantInput?.value || null;

    this.addonVariantId = el.dataset.addonVariantId || null;
    this.addonQty = parseInt(el.dataset.addonQty || '1', 10) || 1;
    this._addonAdding = false;

    this.cards.forEach((card) => {
      card.addEventListener('click', () => this.select(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.select(card);
        }
      });
    });

    if (this.addonVariantId && productForm) {
      productForm.addEventListener('cart:update', (e) => this._onCartUpdate(e));
    }

    document.addEventListener('variant:update', () => {
      if (this._variantInput) {
        this._soleVariantId = this._variantInput.value || this._soleVariantId;
      }
      const selected = this.cards.find(c => c.getAttribute('aria-selected') === 'true');
      if (selected) this._applyBundleVariant(selected);
    });

    const preSelected = el.querySelector('[aria-selected="true"]');
    if (preSelected) {
      this.applyQty(preSelected);
      this._applyBundleVariant(preSelected);
      Promise.resolve().then(() => document.dispatchEvent(new CustomEvent('sm:bundle:select', {
        detail: { option: preSelected.dataset.bundleOption }
      })));
    }
  }

  select(card) {
    this.cards.forEach((c) => {
      c.setAttribute('aria-selected', 'false');
      c.classList.remove('sm-bundle-card--selected');
    });
    card.setAttribute('aria-selected', 'true');
    card.classList.add('sm-bundle-card--selected');
    this.applyQty(card);
    this._applyBundleVariant(card);
    document.dispatchEvent(new CustomEvent('sm:bundle:select', {
      detail: { option: card.dataset.bundleOption }
    }));
  }

  applyQty(card) {
    const qty = parseInt(card.dataset.bundleQty, 10);
    if (!this.qtyComponent || isNaN(qty)) return;
    this.qtyComponent.setValue(qty.toString());
  }

  _applyBundleVariant(card) {
    if (!this._variantInput) return;
    const form = this._variantInput.closest('form');

    const sizeMapJson = card.dataset.sizeVariantMap;
    if (sizeMapJson) {
      try {
        const sizeMap = JSON.parse(sizeMapJson);
        const lookupId = this._soleVariantId || this._mainVariantId || this._variantInput.value;
        const bundleId = sizeMap[lookupId];
        if (bundleId) {
          this._variantInput.value = String(bundleId);
          this._setBundleProperty(form, true);
          return;
        }
      } catch (_) {}
    }

    const bundleVariantId = card.dataset.bundleVariantId;
    if (bundleVariantId) {
      this._variantInput.value = bundleVariantId;
      this._setBundleProperty(form, true);
      return;
    }

    this._variantInput.value = this._soleVariantId || this._mainVariantId || '';
    this._setBundleProperty(form, false);
  }

  _setBundleProperty(form, isBundle) {
    if (!form) return;
    const propName = 'properties[_is_bundle]';
    let input = form.querySelector(`input[name="${propName}"]`);
    if (isBundle) {
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = propName;
        form.appendChild(input);
      }
      input.value = 'true';
    } else {
      input?.remove();
    }
  }

  _onCartUpdate(e) {
    if (this._addonAdding) return;
    if (e.detail?.data?.source !== 'product-form-component') return;
    if (e.detail?.data?.didError) return;
    this._addAddon();
  }

  async _addAddon() {
    if (!this.addonVariantId || this._addonAdding) return;
    this._addonAdding = true;

    const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')]
      .map(el => el.dataset.sectionId)
      .filter(Boolean)
      .join(',');

    const mainVariantId = this._variantInput?.value;
    const body = {
      items: [{
        id: Number(this.addonVariantId),
        quantity: this.addonQty,
        properties: mainVariantId ? { '_linked_main_variant': mainVariantId } : {}
      }]
    };
    if (sectionIds) body.sections = sectionIds;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.status) throw data;

      const cart = await fetch('/cart.js').then(r => r.json());

      const ev = new Event('cart:update', { bubbles: true });
      ev.detail = {
        resource: cart,
        sourceId: 'sm-addon',
        data: { source: 'sm-addon', sections: data.sections }
      };
      document.dispatchEvent(ev);

    } catch (err) {
      console.error('[sm-addon]', err);
    } finally {
      this._addonAdding = false;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sm-bundle-picker').forEach((el) => new SmBundlePicker(el));
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sm-gift-panels"] && !Shopify.designMode) return;
  try {
    class SmGiftPanels {
  constructor(el) {
    this.panels = [...el.querySelectorAll('[data-gift-panel]')];

    // Move each panel to sit directly after its card in the bundle picker.
    // This puts card + panel in natural DOM order so CSS layout handles all
    // shifting — no JS DOM moves needed during interactions.
    this.panels.forEach(panel => {
      const card = document.querySelector(`[data-bundle-option="${panel.dataset.giftPanel}"]`);
      if (card) card.after(panel);
    });
    el.remove();

    // Place the ebook strip after the last panel
    const lastPanel = this.panels[this.panels.length - 1];
    const ebook = document.querySelector('.sm-standalone-ebook-strip');
    if (ebook && lastPanel) {
      lastPanel.after(ebook);
      ebook.classList.add('sm-standalone-ebook-strip--in-picker');
    }

    const selected = document.querySelector('[data-bundle-option][aria-selected="true"]');
    if (selected) this._apply(selected.dataset.bundleOption, false);

    document.addEventListener('sm:bundle:select', e => this._apply(e.detail.option));
  }

  _apply(activeOption, animate = true) {
    document.querySelectorAll('[data-bundle-option]').forEach(c => c.classList.remove('sm-bundle-card--panel-open'));

    if (!animate) {
      this.panels.forEach(p => {
        p.style.transition = 'none';
        const inner = p.querySelector('.sm-gift-panel__inner');
        if (inner) inner.style.transition = 'none';
      });
    }

    this.panels.forEach(p => {
      const isActive = p.dataset.giftPanel === activeOption;
      p.classList.toggle('sm-gift-panel--open', isActive);
      if (isActive) {
        const card = document.querySelector(`[data-bundle-option="${activeOption}"]`);
        if (card) card.classList.add('sm-bundle-card--panel-open');
      }
    });

    if (!animate) {
      requestAnimationFrame(() => {
        this.panels.forEach(p => {
          p.style.transition = '';
          const inner = p.querySelector('.sm-gift-panel__inner');
          if (inner) inner.style.transition = '';
        });
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.sm-gift-panels');
  if (el) new SmGiftPanels(el);
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sm-pdp-accordions"] && !Shopify.designMode) return;
  try {
    class SmAccordionGroup extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('details').forEach((detail) => {
      const summary = detail.querySelector('summary');
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        if (detail.open) {
          this._close(detail);
        } else {
          this.querySelectorAll('details[open]').forEach((other) => this._close(other));
          this._open(detail);
        }
      });
    });
  }

  _open(detail) {
    detail.open = true;
    const body = detail.querySelector('.sm-pdp-accordion__body');
    const h = body.scrollHeight;
    body.animate(
      [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
      { duration: 300, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'none' }
    );
  }

  _close(detail) {
    const body = detail.querySelector('.sm-pdp-accordion__body');
    const h = body.scrollHeight;
    const anim = body.animate(
      [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: 250, easing: 'cubic-bezier(0.4, 0, 0.2, 1)', fill: 'forwards' }
    );
    anim.onfinish = () => {
      detail.open = false;
      anim.cancel();
    };
  }
}
if (!customElements.get('sm-accordion-group')) {
  customElements.define('sm-accordion-group', SmAccordionGroup);
}
  } catch(e) { console.error(e); }
})();

})();
